import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/cn';

export function Spinner({ className, size = 20 }: { className?: string; size?: number }) {
  return <Loader2 className={cn('animate-spin text-brand-600', className)} size={size} />;
}

/** Spinner centrado para estados de carga a pantalla completa de una sección. */
export function SpinnerOverlay({ label }: { label?: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16 text-slate-400">
      <Spinner size={28} />
      {label && <p className="text-sm">{label}</p>}
    </div>
  );
}
